import { Location } from '@ftr/contracts/api/location'
import { ChildLocation, RootLocation } from '../../utils'
import { LocationViewModel } from './location-view-model'

export interface ToggleableRootLocation extends Location {
  children: LocationViewModel[]
  open: boolean
}

export function mapToToggleableRootLocations(locations: RootLocation[]): ToggleableRootLocation[] {
  return locations.map(location => mapToToggleableRootLocation(location))
}

function mapToToggleableRootLocation(location: RootLocation): ToggleableRootLocation {
  return {
    ...location,
    children: location.children.map(child => mapToLocationViewModel(child)),
    open: true,
  }
}

function mapToLocationViewModel(child: ChildLocation): LocationViewModel {
  return { ...child, isShowing: true }
}
